import { Injectable } from '@angular/core';
import axios from 'src/app/Service/axios';
import { DriverSalaryResponse, DriverSalaryStatus } from './driver-salary-report.models';
@Injectable({ providedIn: 'root' })
export class DriverSalaryReportApiService {
  async post(endpoint: string, payload: object): Promise<DriverSalaryResponse> {
    const response = await axios.post(endpoint, payload);
    const result: unknown = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
    if (Array.isArray(result)) return result;
    if (result && typeof result === 'object') return result as DriverSalaryStatus;
    throw new Error('پاسخ گزارش نامعتبر است');
  }
  upload(vehicleId: string, file: File): Promise<DriverSalaryResponse> {
    const payload = new FormData(); payload.append('uploadFile', file, file.name);
    return this.post(`MobileReadExcelFile?strUnitID=${vehicleId}`, payload);
  }
}
